import ajax from "./request.js";

let bool = process.env.NODE_ENV === "production";
const href = bool
  ? `https://${window.location.host}/api/cloud/file`
  : "/api/cloud/file";

function queryMaterialsList(data) {
  return ajax(`${href}/list`, {
    method: "POST",
    data,
  });
}

function uploadMaterial(data) {
  return ajax(`${href}/uploadFile`, {
    method: "POST",
    data,
  });
}

function uploadMaterialForm({ base64, fileName, fileType = 'picture' }) {
  const form = new FormData();
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'image/png' });
  form.append('file', blob, fileName.endsWith('.png') ? fileName : `${fileName}.png`);
  form.append('file_type', fileType);
  return ajax(`${href}/uploadFile`, {
    method: 'POST',
    data: form,
    requestType: 'form',
  });
}
function deleteMaterial(data) {
  return ajax(`${href}/delete`, {
    method: "POST",
    data,
  });
}

export default { queryMaterialsList, uploadMaterial, uploadMaterialForm, deleteMaterial };
